// Package imports:
import React, { useState } from 'react'
import cx from 'classnames'
// Component imports:
import Icon from '../CustomIcon/CustomIcon';

interface IProps {
    triggerLabel: string
}

const NavDropdown: React.FC<IProps> = ({
    triggerLabel,
    children
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <li className={cx('nav__main-list', {'is-open': isOpen})}>
            <button type="button" onClick={() => setIsOpen(!isOpen)}>
                {triggerLabel}
                <span className="icon">
                    <Icon type="dropdown-arrow" />
                </span>
            </button>
            {children}
        </li>
    )
}

export default NavDropdown;
